import React from "react";
import Skeleton from "react-loading-skeleton";

const ActionsInvestisseurTableSkeleton = () => {
    return(
        <div className="col-md-12 as-col-table-container">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th scope="col"  style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >N</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Projet</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >Nombre d'actions</th>
                        <th scope="col" style={{ color:'var(--secondary-color)', fontSize: '16px', lineHeight: '24px', fontWeight: 'bold'}} >PDF</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                    <tr>
                        <th><Skeleton/></th>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                        <td><Skeleton/></td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default ActionsInvestisseurTableSkeleton;